import React from "react";
import type { TimeValue } from "react-aria";
import { useLocale, useTimeField } from "react-aria";
import type { TimeFieldStateOptions } from "react-stately";
import { useTimeFieldState } from "react-stately";
import type { Props as FieldProps } from "../Form/Field";
import Field from "../Form/Field";
import DateSegment from "../DatePicker/DateSegment";
import { styled } from "@linaria/react";

const TimeFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 7px 0px;
  padding-right: 8px;
  flex-grow: 1;
`;

const StyledField = styled(Field)`
  //width: 100%;
  & > button:not(.visible) {
    display: none;
  }
`;

interface P<T extends TimeValue = TimeValue> extends FieldProps {
  timeOptions?: Partial<Omit<TimeFieldStateOptions<T>, "locale" | "label">>;
}

export function TimeField<T extends TimeValue = TimeValue>({ timeOptions, ...fieldProps }: P<T>) {
  const { locale } = useLocale();
  const state = useTimeFieldState({
    ...timeOptions,
    locale,
  });

  const ref = React.useRef(null);
  const { fieldProps: ariaFieldProps } = useTimeField({ ...timeOptions }, state, ref);

  return (
    <StyledField {...fieldProps}>
      <TimeFieldWrapper {...ariaFieldProps} ref={ref}>
        {state.segments.map((segment, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <DateSegment key={i} segment={segment} state={state} />
        ))}
      </TimeFieldWrapper>
    </StyledField>
  );
}
